import { useAppDispatch } from './state'
import {
  getPolicies as getPoliciesAPI,
  getPolicy as getPolicyAPI,
  IPostRebuildValueMeterData,
  requestPolicyAdvise as requestPolicyAdviseAPI,
  postRebuildValueMeter as postRebuildValueMeterAPI,
  postContentsInsuranceValue as postContentsInsuranceValueAPI,
  IPostContentsInsuranceValueData,
  generateInsuranceCard as generateInsuranceCardAPI
} from '../api/policies'
import {
  setIsLoadingInsuranceCard,
  setIsPoliciesLoading,
  setPolicies,
  setValueMeterIsLoading,
  updatePolicy
} from '../state/slices/policies_slice'
import { useNavigate } from 'react-router-dom'

export const usePolicies = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const getPolicies = async () => {
    dispatch(setIsPoliciesLoading(true))

    try {
      const result = await getPoliciesAPI()

      if (result.data) {
        dispatch(setPolicies(result.data ?? []))
      }
    } finally {
      dispatch(setIsPoliciesLoading(false))
    }
  }

  const getPolicy = async (id: string) => {
    dispatch(setIsPoliciesLoading(true))

    try {
      const result = await getPolicyAPI(id)

      if (result.data) {
        dispatch(updatePolicy(result.data))
      }
    } finally {
      dispatch(setIsPoliciesLoading(false))
    }
  }

  const postRebuildValueMeter = async (
    id: string,
    data: IPostRebuildValueMeterData
  ) => {
    dispatch(setValueMeterIsLoading(true))

    try {
      await postRebuildValueMeterAPI(id, data)
    } finally {
      dispatch(setValueMeterIsLoading(false))
    }
  }

  const postContentsInsuranceValue = async (
    id: string,
    data: IPostContentsInsuranceValueData[]
  ) => {
    dispatch(setValueMeterIsLoading(true))

    try {
      await postContentsInsuranceValueAPI(id, data)

      navigate('/dossier/waardemeters')
    } finally {
      dispatch(setValueMeterIsLoading(false))
    }
  }
  const requestPolicyAdvise = async (
    relationId: string,
    agencyId: string,
    adviseExplanation: string,
    products: string[]
  ) => {
    await requestPolicyAdviseAPI(
      relationId,
      agencyId,
      adviseExplanation,
      products
    )
  }

  const generateInsuranceCard = async (policyId: string, vehicleId: string) => {
    dispatch(setIsLoadingInsuranceCard(true))
    try {
      await generateInsuranceCardAPI(policyId, vehicleId)

      navigate(`/verzekeringen/polis/${policyId}`)
    } finally {
      dispatch(setIsLoadingInsuranceCard(false))
    }
  }

  return {
    getPolicies,
    getPolicy,
    requestPolicyAdvise,
    postRebuildValueMeter,
    postContentsInsuranceValue,
    generateInsuranceCard
  }
}

export default usePolicies
